var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPublicTransport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 24,
  viewBox: "0 0 20 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 18v3h2v-3h2v5H0v-5zM14 18v3h2v-3h2v5h-6v-5zM19 10v2H-1v-2zM19 3v2H-1V3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16-1H2C.3-1-1 .3-1 2v18h20V2c0-1.7-1.3-3-3-3m0 2h.1c.5.1.9.5.9 1v16H1V2c0-.6.4-1 1-1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 15,
  r: 1
}))));
export default SvgPublicTransport;